// For Now, Fns Used to Calculate Pt Conversions From DB to Viewer Shape

module.exports = {

    INCHES_TENTHS_MM_TRANS: 0.00393701, // adjust x,y coordinates by this times the current page dpi (INCHES_TENTHS_MM_TRANS) ( divide by 25.4)

    // (Not Cold; 'Coordinate Shapes)
    // COULD HAVE A FLAG FOR DIVIDE / MULTIPLY AND USE FOR BOTH  ...
    // rounding ...
    adjustPtsFromDbToViewer: function( pts, scale, pgDPI, pgRotation, originalPgCenter ) {

        var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI * scale;

        if (pgRotation === 0) {

            return pts.map( function(p) {
                return {x: p.x * conv, y: p.y * conv };
            });
        }

        // Rotated
        var center = originalPgCenter,
            rotRadians = Raphael.rad(pgRotation),
            sinTheta = Math.sin(rotRadians),
            cosTheta = Math.cos(rotRadians),
            centerRotated = { //rotate image center
                x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
                y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
            };

        return pts.map( function(p) {
            var dCenter = {   //diff from current point to current center
                    x: p.x - center.x,
                    y: p.y - center.y
                },
                rdCenter = {   // rotate dCenter (rotated diff of current pt from current center)
                    x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
                    y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
                }; ///the rotated different from the center plus the rotated center
            return {
                x: (rdCenter.x + centerRotated.x) * conv,
                y: (rdCenter.y + centerRotated.y) * conv
            };
        });

    },

    // Now only used for Floating Reason Codes.
    // Same as above, but don't take page rotation or scale into account
    // unlike base shape -- using transforms, so don't apply scale and rotation adjustments ---  just dpi and the conversionConstant
    // when get rid of transforms, this will be the way to go ...
    adjustPtsFromDbToViewerWithoutTransform: function( pts, pgDPI ) {

        return this.adjustPtsFromDbToViewer( pts, 1, pgDPI, 0 );

    },
    
    // pts typically come from a raphael element when persisting
    
    adjustPtsFromViewerToDb: function( pts, isCold, scale, pgDPI, pgRotation, originalPgCenter, pgOverlay ) {


        if ( !isCold ) {

            var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI * scale;

            if (pgRotation === 0) {
                return  _.map( pts , function(p) {
                    return {
                        x: +(p.x / conv).toFixed(3),
                        y: +(p.y / conv).toFixed(3)
                    };
                });
            }

            //rotation adjustment -- normalize pts back to 0 -- to be read in by other fn --- note --same logic for svg but applicable to path
            var center = originalPgCenter, //get center w/current Rotation
                rotTo0 =  -1 * pgRotation,
                rotRadians = Raphael.rad(rotTo0),
                sinTheta = Math.sin(rotRadians),
                cosTheta = Math.cos(rotRadians),
                centerRotated = { //rotate image center
                    x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
                    y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
                };

            return _.map( pts, function(p) {

                var dCenter = {
                        x: (p.x / conv) - center.x,   //!!ONLY APPY THE CONVERSION TO THE POINT !!!
                        y: (p.y / conv) - center.y
                    }, //diff from current point to current center
                    rdCenter = {   // rotate dCenter (rotated diff of current pt from current center)
                        x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
                        y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
                    }, ///the rotated different from the center plus the rotated center
                    newPt = {
                        x: rdCenter.x + centerRotated.x,
                        y: rdCenter.y + centerRotated.y
                    };

                return {
                    x: +newPt.x.toFixed(3),
                    y: +newPt.y.toFixed(3)
                };

            });

        } else {

            // COLD -- convert the 'pixel' coordinates to the cold 'grid' coordinates -- always a rectangle
            // -1 is for base 0 which is how they appear to be saved in fat client

            var o = pgOverlay,
                coordinates = _.map(pts, function(p) {
                    return  {
                        x: Math.ceil( (p.x / 96 * o.cpi) / scale) - 1, /* no fractions in 'coordinates' -- is ceil correct -- always go to the larger size ? */
                        y: Math.ceil( (p.y / 96 * o.lpi) / scale) - 1
                    };
                });

            /* validate both horizontal and vertical dimensions are at least 1 */
            var rectW = coordinates[1].x - coordinates[0].x,
                rectH = coordinates[3].y - coordinates[0].y;

            if (rectW === 0) {
                coordinates[1].x += 1;
                coordinates[2].x += 1;
            }

            if (rectH === 0) {
                coordinates[2].y += 1;
                coordinates[3].y += 1;
            }

            return coordinates;
        }

    },

    /**
     * Was used in initial iteration for  find and redact --
     * Currently unused ...
     */
    adjustPtsFromPxToTenthsMM: function( pts, dpi ) {

        var conv = this.INCHES_TENTHS_MM_TRANS * dpi;

        return  _.map( pts , function(p) {
            return {
                x: +(p.x / conv).toFixed(3),
                y: +(p.y / conv).toFixed(3)
            };
        });

    },

    // For now only used for floating reason code box (not the connection).
    // Sure, could be more elegant -- but do some when start creating other shapes that don't have transforms included.
    // Note: don't need to account for COLD pages for the Floating Codes note type.
    // Now: also utilized for full page redactions -- see getPointsToSaveFromPageDimensions
    adjustPtsFromViewerToDbNoTransform: function(pts, pgDPI) {

        var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI;

        return _.map( pts , function(p) {
            return {
                x: +(p.x / conv).toFixed(3),
                y: +(p.y / conv).toFixed(3)
            };
        });

    },


    /**
     * Was only used in codesView -- like adjustPtsFromViewerToDb but doesn't take cold, conversion, dpi into account
     * note: obvious area for code consolidation
     * Now also used in hoverTextStamp ...
     * Should put in Util or on the transformedMixinHelper -- 'inversePageRotate'
     */
    getPtsWithoutTransformApplied: function( pts, scale, pageRotation, originalPgCenter ) {

        var newCoordinates = pts.map( function(p) {
            return {
                x: (p.x / scale),
                y: (p.y / scale)
            };
        });

        if ( pageRotation === 0 )
            return newCoordinates;

        var center = originalPgCenter,
            rotTo0 =  -1 * pageRotation,
            rotRadians = Raphael.rad(rotTo0),
            sinTheta = Math.sin(rotRadians),
            cosTheta = Math.cos(rotRadians),
            centerRotated = { //rotate image center
                x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
                y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
            };

        newCoordinates = newCoordinates.map( function(p) {

            var dCenter = {
                    x: (p.x) - center.x,
                    y: (p.y) - center.y
                },
                rdCenter = {
                    x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
                    y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
                },
                newPt = {
                    x: rdCenter.x + centerRotated.x,
                    y: rdCenter.y + centerRotated.y
                };

            return {
                x: newPt.x,
                y: newPt.y
            };

        });

        return newCoordinates;
    },

    /**
     * Now used for full page redactions.
     * Post refactor to apply transforms to all shape types, will likely not be necessary.
     * Note: N/A for cold pages currently.
     */
    getPointsToSaveFromPageDimensions: function( page ) {

        if ( page.isCold() )
            return;

        var originalPageDimensions = page.originalDimensions();

        var dimensionsAsPoints = [
            { x: 0, y: 0},
            { x: originalPageDimensions.w,  y: 0},
            { x: originalPageDimensions.w, y: originalPageDimensions.h },
            { x: 0, y: originalPageDimensions.h }
        ];

        return this.adjustPtsFromViewerToDbNoTransform( dimensionsAsPoints,  page.getDPI() );

    },


    /*
    * Return array of pts from 'getPtsWithoutTransformApplied' or similar in rectangle order (it may not return this in order if rotation is applied).
    * Assumes it's a rectangle.
    * Presumably better way to do this that doesn't require this extra call, perhaps could combine the 2.
    * Probably belongs elsewhere but here for now to show where the Math comes from ( only used for this purpose )
    * */
    getPtsInRectOrder: function(pts) {

        var xs = _.map(pts, function(p) {
            return p.x;
        });

        var ys = _.map(pts, function(p) {
            return p.y;
        });

        var minX = Math.min.apply( null, xs );
        var maxX = Math.max.apply( null, xs );
        var minY = Math.min.apply( null, ys );
        var maxY = Math.max.apply( null, ys );

        return [
            { x: minX, y: minY },
            { x: maxX, y: minY },
            { x: maxX, y: maxY },
            { x: minX, y: maxY }
        ];

    },


    ptToPx: function( pt ) {
        return pt * 96 / 72;
    },

    pxToPt: function( px ) {
        return px / 96 * 72;
    },

    ptToTenthsMM: function( pt ) {
        return pt * (1/72) / this.INCHES_TENTHS_MM_TRANS;
    },

    // Currently used in Find and Redact
    pxToTenthsMM: function( px, dpi ) {

        var conv = this.INCHES_TENTHS_MM_TRANS * dpi;

        return  parseFloat( (px / conv).toFixed( 3  ));

    }

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/shapeUtils.js
 ** module id = 197
 ** module chunks = 0
 **/